export default class WCAG {
  static navigateToAndFocus = ({
    element,
    addNavigation = false,
  }: {
    element: HTMLElement
    addNavigation: boolean
  }): void => {
    if (!element) return

    if (addNavigation) {
      element.setAttribute('tabindex', '0')
    }
    element.scrollIntoView()
    element.focus()
  }

  private static getPressedKey = (e: KeyboardEvent): number => {
    return e?.keyCode
  }

  static getFocusedElement = (): Element | null => {
    return document.activeElement
  }

  static isEscPressed = (e: KeyboardEvent): boolean => {
    return this.getPressedKey(e) === 27
  }

  static isEnterPressed = (e: KeyboardEvent): boolean => {
    return this.getPressedKey(e) === 13
  }

  static isSpacebarPressed = (e: KeyboardEvent): boolean => {
    return this.getPressedKey(e) === 32
  }

  static isTabPressed = (e: KeyboardEvent): boolean => {
    return this.getPressedKey(e) === 9
  }

  static isShiftTabPressed = (e: KeyboardEvent): boolean => {
    return e.shiftKey && this.isTabPressed(e)
  }
}
